import { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { Link, useNavigate } from 'react-router-dom';

import { Dropdown, Menu } from '@arco-design/web-react';
import { IconDown, IconImport } from '@arco-design/web-react/icon';

import { ConfigContext } from '@/components/ConfigProvider/configProvider';
import { RenderIcon } from '@/components/CustomAvatar';
import { useLangContext } from '@/hooks';
import { loginOut } from '@/service/youseself';
import { clearStorage } from '@/utils/useLocalStorage';

import styles from '../styles/index.module.less';

export default function User() {
  const { t } = useTranslation();
  const { isLogin, userInfo } = useContext(ConfigContext);
  const navigate = useNavigate();
  const { lang } = useLangContext();

  if (!isLogin)
    return (
      <Link to="/login" className={`${styles['navbar-right-btn']} ${styles['navbar-right-btn-login']}`}>
        {t('login-page:login')}
      </Link>
    );

  const dropList = (
    <Menu>
      <Menu.Item
        key="1"
        onClick={() => {
          navigate('/personal/password');
        }}
      >
        <RenderIcon Icon="icon-gerenzhongxin" style={{ marginRight: 12, fontSize: 14 }} />
        <span>{t('common:personal.center')}</span>
      </Menu.Item>
      <Menu.Item
        key="2"
        onClick={async () => {
          try {
            clearStorage();
            sessionStorage.clear();
            localStorage.setItem('lang', lang);
            await loginOut();
            window.location.href = '/login';
          } catch (e) {
            console.error(e);
          }
        }}
      >
        <IconImport style={{ marginRight: 12 }} />
        <span>{t('user:logout')}</span>
      </Menu.Item>
    </Menu>
  );
  return (
    <Dropdown droplist={dropList} position="br" trigger={['click']}>
      <span className={styles['navbar-right-btn']}>
        {userInfo?.name}
        <IconDown style={{ marginLeft: 6, color: 'var(--color-text-2)', marginTop: 3 }} />
      </span>
    </Dropdown>
  );
}
